import React from 'react'

import { RHFInput } from 'react-hook-form-input'
import useForm from 'react-hook-form'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  TextField,
} from '@material-ui/core'

import helpers from 'helpers'
import schemas from './../../schemas'

const DialogInvoicesEmails = ({ open, email, onSubmit, onClose }) => {
  const { register, setValue, handleSubmit, errors } = useForm({
    validationSchema: schemas.editEmail,
    defaultValues: {
      id: email.id,
      quantityDaysToDueDate: email.variables.quantityDaysToDueDate || '',
    },
  })

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="edit-email">
      <DialogTitle>
        <div>
          <Typography variant="h4">Editar email</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <form id="edit-email" onSubmit={handleSubmit(onSubmit)}>
          <RHFInput
            as={<TextField type="hidden" />}
            name="id"
            register={register}
            setValue={setValue}
          />

          <TextField
            margin="dense"
            label="Descrição"
            value={email.description}
            disabled
            fullWidth
          />

          <RHFInput
            as={
              <TextField
                margin="dense"
                label={helpers.emails.formatQuantityDaysToDueDate(email)}
                type="number"
                error={!!errors.quantityDaysToDueDate}
                helperText={
                  errors &&
                  errors.quantityDaysToDueDate &&
                  errors.quantityDaysToDueDate.message
                }
                fullWidth
              />
            }
            name="quantityDaysToDueDate"
            register={register}
            setValue={setValue}
            mode="onChange"
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          form="edit-email"
        >
          Salvar
        </Button>
        <Button color="primary" variant="outlined" onClick={onClose}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogInvoicesEmails
